import * as firebase from 'firebase';

const config = {
    apiKey: "AIzaSyDvbdjZxiff6p3-xxGsSP3oNIObvU31mzU",
    authDomain: "sonder-social.firebaseapp.com",
    databaseURL: "https://sonder-social.firebaseio.com",
    projectId: "sonder-social",
    storageBucket: "sonder-social.appspot.com",
    messagingSenderId: "934230915012"
};

firebase.initializeApp(config);

let database = firebase.database()

export default database

/**
 * Created by brandonong on 16/1/18.
 */



// WEBPACK FOOTER //
// ./src/loginconfig.js